export function buildNavigationList() {
  const tourSections = document.querySelectorAll('main.tour *[id^="tour-section-"]');
  const navList = document.querySelector('nav.tour__navigation ol');
  if (!navList) return;

  tourSections.forEach(element => {
    if (element.children.length > 0) {
      const listItem = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = `#${element.id}`;
      anchor.textContent = element.dataset.title;
      listItem.appendChild(anchor);
      navList.appendChild(listItem);
    }
  });
}

export function setupNavigationObserver() {
  const navItems = document.querySelectorAll('nav.tour__navigation li');
  const tourSections = document.querySelectorAll('main.tour *[id^="tour-section-"]');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.getAttribute('id');
        navItems.forEach(item => {
          const link = item.querySelector('a');
          item.classList.toggle('is-active', '#' + id === link.getAttribute('href'));
        });
      }
    });
  }, { threshold: 0 });

  tourSections.forEach(section => {
    observer.observe(section);
  });
}
